const getters = {};

const state = {
  processing: false,
  snackbar: false,
  text: '',
  color: '',
  confirm: false,
  confirmText: '',
  afterConfirm: null,
};

const mutations = {
  setProcessing: (state) => {
    state.processing = true;
  },
  unsetProcessing: () => {
    state.processing = false;
  },
  setSnackbar: (state, { text, color }) => {
    state.snackbar = true;
    state.text = text;
    state.color = color;
  },
  unsetSnackbar: () => {
    state.snackbar = false;
    state.text = '';
    state.color = '';
  },
  setConfirm: (state, { confirmText, afterConfirm }) => {
    state.confirm = true;
    state.confirmText = confirmText;
    state.afterConfirm = afterConfirm;
  },
  unsetConfirm: () => {
    state.confirm = false;
    state.confirmText = '';
    state.afterConfirm = null;
  },
};

const actions = {
  showProgress: ({ commit }) => {
    commit('setProcessing');
  },
  hideProgress: ({ commit }) => {
    commit('unsetProcessing');
  },
  openSnackbar: ({ commit }, { text, color }) => {
    commit('setSnackbar', { text: text, color: color });
  },
  closeSnackbar: ({ commit }) => {
    commit('unsetSnackbar');
  },
  showConfirm: ({ commit }, { confirmText, afterConfirm }) => {
    commit('setConfirm', { confirmText: confirmText, afterConfirm: afterConfirm });
  },
  hideConfirm: ({ commit }) => {
    commit('unsetConfirm');
  },
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};